module.exports = __webpack_public_path__ + "vant-encapsulation/images/right.1703577108441.png";